export const DAYS  = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
export const MEALS = ["Breakfast","Lunch","Dinner","Snacks","Protein Shake"];

// Meals used as a fallback when nothing has been logged yet.
export const DAILY_DEFAULTS = {
  "Breakfast": {
    description: "Protein oats",
    ingredients: [
      { name: "oats",        amount: 40,  unit: "g" },
      { name: "pea protein", amount: 31,  unit: "g" },
      { name: "sugar",       amount: 8,   unit: "g" },
      { name: "almond milk", amount: 120, unit: "g" },
    ],
  },
  "Protein Shake": {
    description: "Pea protein shake with berries",
    ingredients: [
      { name: "pea protein",    amount: 35,  unit: "g" },
      { name: "frozen berries", amount: 150, unit: "g" },
    ],
  },
};

export const VIEWS = ["Dashboard","Meal Log","Supply","History","Progress","Fitness","Foods","Profile","Admin"];

export const DEFAULT_MACRO_GOALS = { calories:2000, protein:150, carbs:200, fat:65, fiber:30 };

export const DEFAULT_FITNESS_GOALS = {
  bodyFatCurrent: 27, bodyFatTarget: 10,
  bodyFatAnchorWeight: 89.25, bodyFatAnchorPercent: 27,
  weightCurrent:  89.25, weightTarget: 72,
  muscleCurrent:  37, muscleTarget: 42,
  runDistTarget:  5, runPaceTarget: 25,
  neck: 0, waist: 0, height: 175, age: 32,
};
